'use client';
import { IProduct } from '@mybestbrands/types';
import { useEffect, useState } from 'react';
import { getCookie } from 'cookies-next';
import { COOKIE_NAMES } from '@/app/constants';

const PdpEditorHelper = ({ product }: { product: IProduct }) => {
  const [ehMode, setEhMode] = useState<boolean>(false);
  useEffect(() => {
    setEhMode(!!getCookie(COOKIE_NAMES.EH_MODE));
  }, []);

  if (!ehMode) return null;

  return (
    <div className={'d-flex align-items-center gap-2'}>
      <strong>Original product IDs:</strong>
      <div>{product.originalProductIds.join(', ')}</div>
    </div>
  );
};

export default PdpEditorHelper;
